<template>
  <div class="color-dot" v-show="getVisibility" :style="getDotColor"></div>
</template>

<script>
export default {
  props: [
    'select',
    'itemData',
    'forceColor'
  ],
  computed : {
    getVisibility () {
      return this.select === 'nozzles' ||
        this.select === 'plates' ||
        this.select === 'motors' ||
        this.select === 'diffusers' ||
        this.select === 'force';
    },
    getDotColor () {
      if (this.$props.select === null) { return; }
      if (this.$props.forceColor === undefined && (this.$props.itemData === null || this.$props.itemData === undefined)) { return; }
      let colorKey = null;
      switch (this.$props.select) {
        case 'nozzles':
          colorKey = 'nozzleColor';
          break;
        case 'plates':
          colorKey = 'plateColor';
          break;
        case 'motors':
          colorKey = 'name';
          break;
        case 'diffusers':
          colorKey = 'diffuser';
          break;
      }
      if (colorKey === null && this.$props.forceColor === undefined) { return; }
      let color = null;
      if (this.$props.forceColor) {
        color = this.$props.forceColor;
      } else {
        color = this.itemData[colorKey];
      }

      if (color === null || color === undefined || !isNaN(color)) {
        return;
      }

      color = color.toLowerCase().replace(/\s+/g, '');

      // color exceptions
      switch (color) {
        case 'wine':
          color = 'maroon';
          break;
        case 'white':
          color = 'whitesmoke';
          break;
        case 'cream':
          color = 'beige';
          break;
        case 'lightred':
          color = 'tomato';
          break;
        case 'lightpurple':
          color = 'thistle';
          break;
        case 'darkbrown':
          color = 'saddlebrown';
          break;
        case 'dk.red':
          color = 'saddlebrown';
          break;
        case 'dk.blue':
          color = 'darkblue';
          break;
      }
      let addStroke = (color === 'whitesmoke') ? ' border: 1px solid gray' : '';
      return 'background-color: ' + color + ';' + addStroke;
    }
  },
};
</script>

<style scoped>
.color-dot {
  width: 10px;
  height: 10px;
  max-width: 10px;
  max-height: 10px;
  min-height: 10px;
  min-width: 10px;
  border-radius: 50%;
}
</style>

<script setup lang="ts">
</script>